module.exports = __webpack_public_path__ + "static/media/outgoing.ab37bcde.wav";